import {Component, OnInit, Inject, ViewChild, AfterViewInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InsuranceService } from '../insurance.service';
import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {ConfigInsurancePayerIdModel} from '../../../models/insurance/config-insurance-payer-id.model';
import {InsuranceCompanySearchResults} from '../models/insurance-company-search-results';
import {InsuranceDataModel} from '../../../models/insurance/insurance-data.model';
import {Subscription} from 'rxjs';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {MatTableDataSource} from '@angular/material/table';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {SelectionModel} from '@angular/cdk/collections';
import {TdoDropdownComponent} from '../../../tdo-controls/common/tdo-dropdown/tdo-dropdown.component';
import {InsuranceRelationEnum} from '../../../models/enum/insurance-relation.enum';
import {PatientDataModel} from '../../../models/patient/patient-data.model';
import {CaseAddProcedureComponent} from '../../case-forms/case-add-procedure/case-add-procedure.component';
import {InsurancePayeridsComponent} from '../insurance-payerids/insurance-payerids.component';
import {InsuranceCompanyPickerComponent} from '../insurance-company-picker/insurance-company-picker.component';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {InsuranceCompanyManagerComponent} from '../insurance-company-manager/insurance-company-manager.component';
import {
  InsuranceSelectFeeScheduleComponent
} from "../insurance-select-fee-schedule/insurance-select-fee-schedule.component";

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
    actions = [];
    EmployerNO: string;
    GroupNO: string;
    OrganizationName: string;
    PayerIDperNEIC: string;
    FeeScheduleID: string;
    FeeScheduleName: string;
    model: InsuranceCompanySearchResults;

    getActionTooltip(actionName: string): string {
        const tooltip = '';
        // switch (actionName) {
        //   case TdoTableActionsEnum.DELETE:
        //     tooltip = `Delete ${this.FirstName + ' ' + this.LastName}`;
        //     break;
        // }
        return tooltip;
    }
}

@Component({
    selector: 'app-insurance-carriers-subscribers',
    templateUrl: './insurance-carriers-subscribers.component.html',
    styleUrls: ['./insurance-carriers-subscribers.component.css']
})
export class InsuranceCarriersSubscribersComponent implements OnInit, AfterViewInit {
    selectedDdlOrganizationExisting: OrganizationDataModel;
    selectedDdlPayerExisting: ConfigInsurancePayerIdModel;

    dataPatient: PatientDataModel;
    dataPatientId: string;
    isNew: boolean = false;
    isLoading: boolean = false;
    dataOrganizations: OrganizationDataModel[] = [];
    insurancePayers: ConfigInsurancePayerIdModel[] = [];
    newDataInsurance: InsuranceDataModel;
    searchCount: number = 0;
    TDOCID: string = localStorage.getItem('TDOCID');
    practiceDefaultFeeScheduleID: string;

    newDataInsurancePayer: string;
    activeDataInsurancePayer: string;

    newFeeScedule: string = '' ;
    activeFeeScedule: string ;



    payerSelected: ConfigInsurancePayerIdModel;

    activeDataInsurance: InsuranceDataModel;
    activeDataInsuranceOrganizationName: string;
    insuranceCompanySearchResults: InsuranceCompanySearchResults[];
    searchSubscription: Subscription;
    isSearching: boolean = false;
    searchTextObj: any = {
        groupCriteria: '',
        employerCriteria: ''
    };
    organizationNameSelectedFromSearchResults: string;
    payerSelectedFromSearchResults: string;
    showNoResultsMessage: boolean = true;
    showDefaultMessage: boolean = true;
    enumOrganizationTypeId = '00000044-1000-0000-0000-000000000002'; // insurance company

    // Table
    tableModel: TdoTableModel;
    // displayedColumns: string[] = ['EmployerNO', 'GroupNO', 'OrganizationName', 'PayerIDperNEIC', 'actions'];
    // displayedColumnsLabels: string[] = ['Employer', 'Group', 'Insurance Company', 'Payer' ];

    displayedColumns: string[] = ['EmployerNO', 'GroupNO', 'OrganizationName', 'PayerIDperNEIC', 'FeeScheduleName' ];
    displayedColumnsLabels: string[] = ['Employer', 'Group', 'Insurance Company', 'Payer', 'Fee Sched' ];

    dataSource: MatTableDataSource<TableViewData>;
    selection = new SelectionModel<TableViewData>(false, []);
    tableViewData: TableViewData[];

    // element refs
    @ViewChild('ddlOrganizationCreateNew') childOrganizationCreateNew: TdoDropdownComponent;
    @ViewChild('ddlPayerCreateCreateNew') childPayerCreateNew: TdoDropdownComponent;
    @ViewChild('ddlOrganizationCreateExisting') childOrganizationCreateExisting: TdoDropdownComponent;
    @ViewChild('ddlPayerCreateCreateExisting') childPayerCreateExisting: TdoDropdownComponent;

    constructor(
        private dialogRef: MatDialogRef<InsuranceCarriersSubscribersComponent>,
        private dialog: MatDialog,
        private datePipe: DatePipe,
        private insuranceService: InsuranceService,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngAfterViewInit(): void {

    }

    ngOnInit() {
        this.dataPatient = this.data.dataPatient;
        this.dataPatientId = this.data.dataPatientId;
        this.isLoading = true;
        const promises = [
            // this.getDataOrganizations(),
            this.getAllCfgPayers(),
            this.insuranceService.getPracticeDefaultFeeScheduleID(this.TDOCID).toPromise()

        ];

        // get values for organization and payer dropdowns
        Promise.all(promises).then((results: any[]) => {
            // this.dataOrganizations = results[0];
            this.insurancePayers = results[0];
            this.practiceDefaultFeeScheduleID = results[1];
            this.isLoading = false;
        }, err => {
            console.log('err');
            this.isLoading = false;
        });

        // execute search
        this.searchForDataInsurance();
    }

    // getDataOrganizations() {
    //   const promise = new Promise((resolve, reject) => {
    //     this.insuranceService.getAllOrganizations()
    //       .subscribe(response => {
    //         resolve(response);
    //       }, err => {
    //         reject(err);
    //       });
    //   });
    //   return promise;
    // }

    getAllCfgPayers() {
        const promise = new Promise((resolve, reject) => {
            this.insuranceService.getAllInsurancePayers()
                .subscribe(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                });
        });
        return promise;
    }

    searchForDataInsurance() {
        this.searchCount++;
        this.isSearching = true;
        this.isNew = false;
        this.activeDataInsurance = null;
        this.insuranceCompanySearchResults = null;
        this.showDefaultMessage = false;

        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }

        this.searchSubscription = this.insuranceService.searchForDataInsurance(this.searchTextObj)
            .subscribe(response => {

                // load table with results
                this.insuranceCompanySearchResults = response;
                this.refreshTableViewData();
                this.isSearching = false;

                if (!this.insuranceCompanySearchResults.length) {
                    this.showNoResultsMessage = true;
                }
                else {
                    this.showNoResultsMessage = false;
                }
            }, err => {
                this.isSearching = false;
                console.log('search error: ', err);
            });
    }

    setActiveDataInsurance(insurance: InsuranceCompanySearchResults) {
        this.isNew = false;
        this.newDataInsurance = null;

        // copy info over to activeDataInsurance
        const newActiveDataInsurance = new InsuranceDataModel();
        newActiveDataInsurance.InsuranceID = insurance.InsuranceID;
        newActiveDataInsurance.TDOIC = insurance.TDOIC;
        newActiveDataInsurance.OrganizationID = insurance.OrganizationID;
        newActiveDataInsurance.Description = insurance.Description;
        newActiveDataInsurance.PayerID = insurance.PayerID;
        newActiveDataInsurance.GroupNO = insurance.GroupNO;
        newActiveDataInsurance.EmployerNO = insurance.EmployerNO;
        this.activeDataInsurance = newActiveDataInsurance;

        // fill in organization and payer labels
        this.organizationNameSelectedFromSearchResults = insurance.OrganizationName;
        this.payerSelectedFromSearchResults = insurance.PayerIDperNEIC;

        // set ddl values
        this.selectedDdlOrganizationExisting = this.dataOrganizations.filter(a => a.OrganizationID === newActiveDataInsurance.OrganizationID)[0];
        if (this.insurancePayers.filter(a => a.PayerID === newActiveDataInsurance.PayerID).length >= 1) {
            this.newDataInsurancePayer = this.insurancePayers.filter(a => a.PayerID === newActiveDataInsurance.PayerID)[0].Oragnization;
        }
    }

    createNewGroup() {
        this.activeDataInsurance = null;
        this.isNew = true;
        this.newDataInsurance = new InsuranceDataModel();
        this.newDataInsurancePayer = '';
        this.newDataInsurance.GroupNO = this.searchTextObj.groupCriteria;
        this.newDataInsurance.EmployerNO = this.searchTextObj.employerCriteria;
    }

    createNewGroupAnytime() {
        this.showDefaultMessage = false;
        this.activeDataInsurance = null;
        this.isNew = true;
        this.newDataInsurance = new InsuranceDataModel();
        this.showNoResultsMessage = true;
        this.newDataInsurance.GroupNO = this.searchTextObj.groupCriteria;
        this.newDataInsurance.EmployerNO = this.searchTextObj.employerCriteria;
    }

    checkIfSaveIsDisabled() {

        if (this.isNew && (!this.newDataInsurance.Description ||
            !this.newDataInsurance.EmployerNO ||
            !this.newDataInsurance.GroupNO ||
            !this.newDataInsurance.OrganizationID ||
            !this.newDataInsurance.PayerID)) {
            return true;
        } else if (this.isNew) {
            return false;
        }

        if (this.activeDataInsurance) {
            return false;
        }

        return true;
    }

    addInsuranceToPatient() {
        if (this.isNew) {

            // first check to see if employer/group combo exists
            this.searchTextObj.employerCriteria = this.newDataInsurance.EmployerNO;
            this.searchTextObj.groupCriteria = this.newDataInsurance.GroupNO;
            this.insuranceService.searchForDataInsuranceExists(this.searchTextObj)
                .subscribe(response => {
                    if (response.length === 0) {
                        // employer/group combo is still unique
                        // create a new dataInsurance in db
                        this.isLoading = true;
                        this.insuranceService.createDataInsurance(this.newDataInsurance)
                            .subscribe(dataInsurance => {

                                // create just a dataPatientInsurance linked to the existing dataInsurance
                                const dataPatientInsurance: PatientInsuranceDataModel = new PatientInsuranceDataModel();
                                dataPatientInsurance.PatientId = this.dataPatientId;
                                dataPatientInsurance.InsuranceID = dataInsurance.InsuranceID;
                                dataPatientInsurance.EmployerNO = dataInsurance.EmployerNO;
                                dataPatientInsurance.GroupNO = dataInsurance.GroupNO;
                                dataPatientInsurance.InsuranceOrder = 99;
                                dataPatientInsurance.CoverageStart = new Date('0001-01-01');
                                dataPatientInsurance.CoverageEnd = new Date('0001-01-01');
                                dataPatientInsurance.PatientInsuranceNO = '';
                                dataPatientInsurance.enumInsuranceRelationId = InsuranceRelationEnum.Self;
                                dataPatientInsurance.SubsciberContactId = this.dataPatient.ContactId;
                                // dataPatientInsurance.SubscriberContact = this.dataPatient.dataContact;
                                dataPatientInsurance.SubsciberBirthdate = this.dataPatient.BirthDate;

                                this.insuranceService.createDataPatientInsurance(dataPatientInsurance)
                                    .subscribe(dataPatientInsurance1 => {
                                        this.isLoading = false;
                                        this.close();
                                    }, err => {
                                        console.log('err 2', err);
                                        this.isLoading = false;
                                        this.showMessage('Error', 'Error adding carrier');
                                    });
                            }, err => {
                                console.log('err 1', err);
                                this.isLoading = false;
                                this.showMessage('Error', 'Error adding carrier');
                            });
                    }
                    else if (response.length === 1) {
                        // select result to active data insurance
                        this.setActiveDataInsurance(response[0]);

                        // add active data insurance to patient
                        this.addExistingInsuranceToPatient();
                    }
                    else {
                        // multiple insurances returned
                        this.showMessage('Error', 'Employer and Group Number combination already exists');
                    }
                }, err => {
                    // show error
                });
        } else {
            // add active data insurance to patient
            this.addExistingInsuranceToPatient();
        }
    }

    addExistingInsuranceToPatient() {

        // create just a dataPatientInsurance linked to the existing dataInsurance
        const dataPatientInsurance: PatientInsuranceDataModel = new PatientInsuranceDataModel();
        dataPatientInsurance.PatientId = this.dataPatientId;
        dataPatientInsurance.InsuranceID = this.activeDataInsurance.InsuranceID;
        dataPatientInsurance.EmployerNO = this.activeDataInsurance.EmployerNO;
        dataPatientInsurance.GroupNO = this.activeDataInsurance.GroupNO;
        dataPatientInsurance.InsuranceOrder = 99;
        dataPatientInsurance.CoverageStart = new Date('1900-01-01');
        dataPatientInsurance.CoverageEnd = new Date('1900-01-01');
        dataPatientInsurance.PatientInsuranceNO = '';
        dataPatientInsurance.enumInsuranceRelationId = InsuranceRelationEnum.Self;
        dataPatientInsurance.SubsciberContactId = this.dataPatient.ContactId;
        // dataPatientInsurance.SubscriberContact = this.dataPatient.dataContact;
        dataPatientInsurance.SubsciberBirthdate = this.dataPatient.BirthDate;

        this.insuranceService.createDataPatientInsurance(dataPatientInsurance)
            .subscribe(dataPatientInsurance1 => {
                this.isLoading = false;
                this.close();
            }, err => {
                console.log('err 2', err);
                this.isLoading = false;
                this.showMessage('Error', 'Error adding carrier');
            });
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    close() {
        this.dialogRef.close(false);
    }

    onTdoTableItemActionClick(event: TdoTableEvent): void {
        const model = (event.value as TableViewData).model;
    // switch (event.action) {
    //   case TdoTableActionsEnum.DELETE:
    // }
    }

    onTdoTableItemClick(event: TdoTableEvent): void {
        const row = event.value as TableViewData;
        const model = (event.value as TableViewData).model;
        this.setActiveDataInsurance(model);
    }

    refreshTableViewData(){
        this.tableViewData = Array.from(this.insuranceCompanySearchResults, (_) => {
            const model = new TableViewData();
            model.EmployerNO = _.EmployerNO;
            model.GroupNO = _.GroupNO;
            model.OrganizationName = _.OrganizationName;
            model.PayerIDperNEIC = _.PayerIDperNEIC;
            model.FeeScheduleName = _.FeeScheduleName;
            model.FeeScheduleID = _.FeeScheduleID;
            model.model = _;
            return model;
        });
        if (!this.tableModel) {
            this.dataSource = new MatTableDataSource(this.tableViewData);
            this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'EmployerNO', 'asc');
            this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
                if (
                    (data.EmployerNO ? data.EmployerNO : '').toLowerCase().includes(filter) ||
          (data.EmployerNO ? data.EmployerNO : '').toLowerCase().includes(filter) ||
          (data.OrganizationName ? data.OrganizationName : '').toLowerCase().includes(filter) ||
          (data.PayerIDperNEIC ? data.PayerIDperNEIC : '').toLowerCase().includes(filter)
                ) {
                    return true;
                }
            };
        }
        else {
            (this.dataSource ).data = this.tableViewData;
            (this.dataSource )._updateChangeSubscription();
        }
    }

    openDialogChooseFeeSchedule(todo: string) {


        const dialogRef = this.dialog.open(InsuranceSelectFeeScheduleComponent, {
            width: '500px',
            height: '650px',
            panelClass: 'dialog',
            data: {

            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {


              this.newDataInsurance.FeeScheduleID= result.FeeScheduleID;

              this.newFeeScedule = result.FeeScheduleName;


            }
        }
        );





    }

    openDialogChoosePayer(todo: string) {
    // open a window to choose a payer
        const dialogRef = this.dialog.open(InsurancePayeridsComponent, {
            width: '800px',
            height: '650px',
            panelClass: 'dialog',
            data: {
                PayerID: this.newDataInsurance ? this.newDataInsurance.PayerID : this.activeDataInsurance.PayerID,
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.payerSelected = result;

                if (todo === 'new') {
                    this.newDataInsurancePayer = this.payerSelected.PayerIDperNEIC + '/' + this.payerSelected.Oragnization;
                    this.newDataInsurance.PayerID = this.payerSelected.PayerID;
                }
                else {
                    // active
                    this.activeDataInsurancePayer = this.payerSelected.PayerIDperNEIC + '/' + this.payerSelected.Oragnization;
                    this.activeDataInsurance.PayerID = this.payerSelected.PayerID;
                }

            }
        }, err => {
        });
    }

    openDialogChooseInsurance(todo: string) {
    // open a window to choose a payer
        const dialogRef = this.dialog.open(InsuranceCompanyPickerComponent, {
            panelClass: 'dialog',
            data: {
                enumOrganizationTypeId: this.enumOrganizationTypeId,
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (todo === 'new') {
                    this.newDataInsurance.OrganizationID = result.org.OrganizationID;
                    this.newDataInsurance.Description = result.org.OrganizationName;
                    this.activeDataInsuranceOrganizationName = result.org.OrganizationName;
                    this.newDataInsurance.FeeScheduleID = result.feeScheduleId;
                    this.newFeeScedule = result.feeScheduleName;

                    console.log(result);

                    if (result.useUCR) {
                        // set feescheduleid to default/ucr
                        this.newDataInsurance.FeeScheduleID = this.practiceDefaultFeeScheduleID;
                        this.newFeeScedule="Default Fee Schedule UCR";
                    }
                }
                else {
                    // active
                    this.activeDataInsurance.OrganizationID = result.org.OrganizationID;
                    this.activeDataInsurance.Description = result.org.OrganizationName;
                    this.activeDataInsuranceOrganizationName = result.org.OrganizationName;
                }
            }
        }, err => {
        });
    }
}
